import { render } from "./UploadFile.vue?vue&type=template&id=ae1dc8be&scoped=true&ts=true"
import script from "./UploadFile.vue?vue&type=script&lang=ts"
export * from "./UploadFile.vue?vue&type=script&lang=ts"

import "./UploadFile.vue?vue&type=style&index=0&id=ae1dc8be&scoped=true&lang=css"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/HeThongPVNB_HV/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae1dc8be"]])

export default __exports__